import React from 'react';
import AuthorBio from '../components/AuthorBio';
import { books } from '../data/mockBooks';
import { Button } from '../components/ui/button';
import { BookOpen, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AuthorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Back Button */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-orange-600 hover:text-orange-700 hover:bg-orange-50 font-semibold"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Books
          </Button>
        </div>
      </div>

      {/* Author Bio */}
      <AuthorBio />

      {/* Author's Books Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black text-gray-900 mb-4">
              Books by Randy Johnson
            </h2>
            <p className="text-lg text-gray-600">
              Explore the complete collection of word search puzzle books
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {books.map((book) => (
              <div
                key={book.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100"
              >
                <div className="relative bg-gradient-to-br from-orange-50 to-white p-6">
                  <img
                    src={book.coverImage}
                    alt={book.title}
                    className="w-full h-64 object-contain mx-auto"
                  />
                  <div className="absolute top-4 right-4 bg-orange-500 text-white px-4 py-2 rounded-full font-bold shadow-lg">
                    {book.price}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
                    {book.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {book.subtitle}
                  </p>
                  <a
                    href={book.amazonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold">
                      <BookOpen className="mr-2 h-4 w-4" />
                      View on Amazon
                    </Button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Ready to Start Puzzling?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Browse our complete collection of word search puzzle books and find your next challenge!
          </p>
          <Button
            onClick={() => navigate('/')}
            size="lg"
            className="bg-white text-orange-600 hover:bg-gray-100 font-bold px-10 py-6 text-lg rounded-full shadow-2xl"
          >
            <BookOpen className="mr-2 h-6 w-6" />
            Explore All Books
          </Button>
        </div>
      </section>
    </div>
  );
};

export default AuthorPage;
